<template>
  <div id="app">
<!--     <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
<NavBar></NavBar>
<Location></Location>

  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import Location from './components/Location.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    Location
  }
}
</script>

<style>

html {
  scroll-behavior: smooth;
}
.navbar-dark .navbar-nav .nav-link {
        color: white !important;
}
#app {
  font-family: 'helvetica', sans-serif;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>
